// Lote 141 (Robson, 28/10/2026) — "marcado" em cinza suave, o mesmo tom do botão "Perguntar" do Painel.
// Vale para botões de filtro/escolha que NÃO são pretos (os pretos — "+ Novo processo", "Todos", "Lista" —
// continuam como estão). Mesmo tom em todo o app: cinza médio com texto branco.
export const SEL_CINZA = "bg-stone-400 border-stone-400 text-white";
